import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TogetherDIPStage } from './../models/app.models';

@Component({
    selector: 'together-auction-dip-stage-select',
    templateUrl: './dip.stage_select.component.html',
    styleUrls: ['./dip.stage-select.component.scss'],
    standalone: false
})
export class TogetherAuctionDIPStageSelectComponent {
    @Input() forward: TogetherDIPStage;
    @Input() backward: TogetherDIPStage;
    @Input() action: TogetherDIPStage;

    @Input() forward_title: string;
    @Input() action_title: string;
    @Input() backward_title: string;
    @Input() show_forward: boolean = true;
    @Input() show_action: boolean = true;
    @Input() show_backward: boolean = true;
    @Input() show_backward_icon: boolean = false;
    @Input() disabled: boolean = false;
    @Input() action_disabled: boolean = false;
    @Input() forward_disabled: boolean = false;
    @Input() backward_disabled: boolean = false;
    @Input() forwardTabIndex: number = 0;
    @Input() actionTabIndex: number = 0;
    @Input() backwardTabIndex: number = 0;


    @Output() on_action = new EventEmitter();
    @Output() on_forward = new EventEmitter();
    @Output() on_backward = new EventEmitter();

    /**
     * Fires output event when forward is clicked.
     */
    onForward() {
        this.on_forward.emit(this.forward);
    }

    /**
     * Fires action event when action is clicked
     */
    onAction() {
        this.on_action.emit(this.action);
    }

    /**
     * Fires action when back is clicked.
     */
    onBackward() {
        this.on_backward.emit(this.backward);
    }


    constructor() { }
}